export const API_KEY = 'pk.18a30fc1839659b35725511319091779';
